import React, { useEffect, useRef } from 'react';
export function MapInfoWindow({ children, map, marker, onClosed, visible, }) {
    const infoWindowRef = useRef(null);
    const contentContainerRef = useRef(null);
    useEffect(() => {
        if (infoWindowRef.current)
            return undefined;
        const infoWindow = new google.maps.InfoWindow();
        infoWindowRef.current = infoWindow;
        infoWindow.addListener('closeclick', () => {
            onClosed === null || onClosed === void 0 ? void 0 : onClosed();
        });
        return () => {
            infoWindow.close();
            infoWindowRef.current = null;
        };
    }, [onClosed]);
    useEffect(() => {
        const infoWindow = infoWindowRef.current;
        const container = contentContainerRef.current;
        if (infoWindow && container) {
            infoWindow.setContent(container);
        }
    }, [children]);
    useEffect(() => {
        const infoWindow = infoWindowRef.current;
        if (!infoWindow || !marker || !map)
            return;
        if (visible) {
            infoWindow.open({ map, anchor: marker });
        }
        else {
            infoWindow.close();
        }
    }, [visible, map, marker]);
    return (React.createElement("div", { ref: contentContainerRef, style: { position: 'relative' } }, children));
}
